
//Base endpoint-------------------
export const Base_Api_Endpoints={
    SpringBoot_API_Endpoint:`${process.env.REACT_APP_CLIENT_FRONTEND_BASE_URL}`
}